<template>
  <div>
    <span class="font_Montserrat font_size_1000rem v3_color_black_knight1">
      {{chartTitle}}
    </span>
    <div class="border_1 border_grey pt-4">
      <highcharts :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';

const getChartOptions = (component) => {
  const commonOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      className: 'donut-with-legend',
      backgroundColor: 'transparent',
      height: component.height,
    },
    credits: {
      enabled: false,
    },
    title: undefined,
    legend: {
      y: 150,
      floating: true,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      symbolHeight: 15,
      symbolWidth: 15,
      symbolRadius: 0,
      width: '100%',
      verticalAlign: 'top',
      navigation: {
        enabled: false,
      },
      title: {
        style: { fontWeight: '400' },
        text: 'Key',
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        center: [null, 50],
        size: 150,
        colors: [
          '#004A5E',
          '#00A0BE',
          '#89D0DE',
          '#AEDDE8',
          '#C2E6ED',
          '#E1F1F6',
          '#F7FAFA'
        ],
      },
    },
    series: [
      {
        name: 'Composition',
        colorByPoint: true,
        innerSize: '70%',
        data: component.chartData,
      },
    ],
  };

  return {
    ...commonOptions,
  };
};

export default {
  name: 'InfoDonutWithLegendV3',
  components: {
    highcharts: Chart,
  },
  props: {
    chartData: Array,
    chartTitle: String,
    height: {
      type: Number,
      default: 470,
    },
  },
  data: function () {
    return {
      chartOptions: null,
    };
  },
  created() {
    this.chartOptions = getChartOptions(this);
  },
  watch: {
    windowWidth: function () {
      this.chartOptions = getChartOptions(this);
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../sass/v3.scss';
.donut-with-legend {
  .highcharts-legend-item.highcharts-pie-series {
    & > span {
      top: 5px !important;
    }
  }
  .highcharts-legend-item {
    tspan {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .highcharts-legend-title {
    @extend .font_Montserrat;
    @extend .font_size_875rem;
    text-transform: uppercase;
  }
}
</style>
